module.exports = __webpack_public_path__ + "static/media/tj.f5c5a342.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/tj.png
// module id = 1997
// module chunks = 0